// extracted by mini-css-extract-plugin
export default {"content":"DemographicQuestionField_content__3TCJZ"};